import axios from 'axios';

const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';
const isPages = isBrowser && /\.pages\.dev$/.test(hostname);
const isProdDomain = isBrowser && /whitelotus\.work$/i.test(hostname);
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

// 生产环境强制使用 api-do.whitelotus.work
let fallbackBase = 'https://api-do.whitelotus.work/springboot6hv37';

// 只在本地开发时使用 localhost
if (isLocalhost && process.env.NODE_ENV === 'development') {
    fallbackBase = 'http://localhost:8080/springboot6hv37';
} else if (!isPages && !isProdDomain && !isLocalhost) {
    // 其他环境使用相对路径
    fallbackBase = '/springboot6hv37';
}

const BASE_URL = (process.env.REACT_APP_API_BASE_URL || fallbackBase).replace(/\/$/, '');

export const api = axios.create({
    baseURL: BASE_URL,
});

// 请求拦截器
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('Token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const API = {
    getCarousel: () => `${BASE_URL}/config/list`,
    getProjects: (params) => `${BASE_URL}/jianshenxiangmu/list?${new URLSearchParams(params)}`,
    uploadFile: () => `${BASE_URL}/file/upload`,
    saveProject: () => `${BASE_URL}/jianshenxiangmu/add`,
};

export const apiCall = (url, method = 'GET', data = null) => {
    return axios({
        url,
        method,
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
    });
};

export default API;
